"use strict";

class PortalController {

	constructor() {

		this.spriteImagSrc = "textures/portal_spot_sprite_256.png";
		this.highlightScaleFactor = 1.5;
		this.highlightOpacity = 0.75;
		this.defaultOpacity = 1.0;
		this.pulseMinOpacity = 0.5;
		this.pulseMaxOpacity = 1.0;

		this.mousePos = {"x": 0, "y": 0};
		this.previousMousePos = {"x": null, "y": null};
		this.isHovering = false;
		this.previouslyHoveredPortal = null;
		this.raycaster = new THREE.Raycaster();
		this.mouseDown = false;
		this.lastMouseDragDistance = 0.0;
		this.mouseDragLimit = 0.025;
		this.hoverTrackingTimeoutInSeconds = 1.0;
		this.lastCreationTime = null;
		this.visibilityDelayInSeconds = 1.0;
		this.isNavigating = false;

		document.addEventListener('mousedown', e => { this.onMouseDown(e); }, false);
		document.addEventListener('mouseup', e => { this.onMouseUp(e); }, false);
		document.addEventListener('mousemove', e => { this.onMouseMove(e); }, false);
		document.addEventListener('touchstart', e => { this.onTouchStart(e); }, false);
		document.addEventListener('touchend', e => { this.onTouchEnd(e); }, false);
		document.addEventListener('touchcancel', e => { this.onTouchCancel(e); }, false);
	}

	onVRModeActivated(visible) {

		let baseClass = "cardboard-clickable-area";

		if(visible) {
			$("#ui-outer")
				.append($("<div>")
				.addClass(baseClass)
				.on('click', (event) => {
					this.onVRButtonEvent(event);
				})
			);
		} else {
			$("."+baseClass).remove();
		}
	}

	onVRButtonEvent(event) {

		this.initiateNavigationEffect();
	}

	onTouchStart(event) {

		let clickedPortal = this.setTouchMousePosAndGetPortalIntersection();

		if(clickedPortal!=null) {
			this.onPortalHoverBegin(clickedPortal);
			this.previouslyHoveredPortal = clickedPortal;
		}
	}

	onTouchCancel(event) {

		this.onPortalHoverBegin(this.previouslyHoveredPortal);
	}

	onTouchEnd(event) {

		let clickedPortal = this.setTouchMousePosAndGetPortalIntersection();

		if(clickedPortal!=null) {
			this.initiateNavigationEffect();
		} else {
			this.onPortalHoverEnd(this.previouslyHoveredPortal);
		}
	}

	onMouseDown(event) {

		// skip this event type on mobile
		if(viewer.isMobile) return;

		this.mouseDown = true;
	}

	onMouseMove(event) {

		// skip this event type on mobile
		if(viewer.isMobile) return;

		this.mousePos.x  = ( event.clientX / window.innerWidth ) * 2 - 1;
		this.mousePos.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

		let hoveredPortal = this.getPortalIntersection(new THREE.Vector2(this.mousePos.x, this.mousePos.y));

		if(!this.isHovering && hoveredPortal!=null) {
			this.onPortalHoverBegin(hoveredPortal);
			this.previouslyHoveredPortal = hoveredPortal;
			this.isHovering = true;
		}

		if(this.isHovering && hoveredPortal===null) {
			this.onPortalHoverEnd(this.previouslyHoveredPortal);
			this.isHovering = false;
		}

		if(this.mouseDown) {

			if(this.previousMousePos.x) {
				this.lastMouseDragDistance += Math.sqrt(Math.pow(this.previousMousePos.y - this.mousePos.y, 2) + Math.pow(this.previousMousePos.x - this.mousePos.x, 2));
			}
		}

		this.previousMousePos.x = this.mousePos.x;
		this.previousMousePos.y = this.mousePos.y;
	}

	onMouseUp(event) {

		// skip this event type on mobile
		if(viewer.isMobile) return;

		this.mouseDown = false;

		let clickedPortal = this.getPortalIntersection(new THREE.Vector2(this.mousePos.x, this.mousePos.y));

		if(clickedPortal!=null) {

			if(this.lastMouseDragDistance < this.mouseDragLimit) {
				this.initiateNavigationEffect(clickedPortal);
			}
		}

		this.lastMouseDragDistance = 0.0;
	}

	onPortalHoverBegin (portal) {

		if(this.isWithinHoverTrackingTimeout()) {
			return;
		}

		this.highlightHoveredPortal(portal, true);
	}

	onPortalHoverEnd (portal) {

		if(this.isWithinHoverTrackingTimeout() || portal === null) {
			return;
		}

		this.highlightHoveredPortal(portal, false);
	}


	isWithinHoverTrackingTimeout() {

		// hack to avoid gettings false hover events while loading a new scene
		return (this.lastCreationTime != null && ((viewer.clock.getElapsedTime() - this.lastCreationTime) < this.hoverTrackingTimeoutInSeconds));
	}

	highlightHoveredPortal(portal, active, scaleEffect=true) {

		this.previouslyHoveredPortal = portal;

		if(portal===null) return;

		if(scaleEffect) {

			let finalScale = (active) ? portal.meta.defaultScale * this.highlightScaleFactor : portal.meta.defaultScale;
			let finalScaleVec = new THREE.Vector3(finalScale, finalScale, finalScale);
			TweenHelpers.animateVector3(portal.scale, finalScaleVec, { duration: 500.0, easing: TWEEN.Easing.Sinusoidal.InOut });

		} else {

			let opacity = (active) ? this.highlightOpacity : this.defaultOpacity;
			portal.material.opacity = opacity;
		}
	}

	showAllPortals(visible) {

		let opacity = (visible) ? this.defaultOpacity : 0.0;

		viewer.scene.traverse (function (object) {

			if (object instanceof THREE.Sprite) {
				if(object.meta != undefined) {
					if(object.meta.type === "portal") {
						object.material.opacity = opacity;
					}
				}
			}
		});
	}

	setTouchMousePosAndGetPortalIntersection() {

		this.mousePos.x = ( event.changedTouches[0].clientX / window.innerWidth ) * 2 - 1;
		this.mousePos.y = - ( event.changedTouches[0].clientY / window.innerHeight ) * 2 + 1;

		let clickedPortal = this.getPortalIntersection(new THREE.Vector2(this.mousePos.x, this.mousePos.y));

		return clickedPortal;
	}

	createPortalSprite(cameraPos, intersectionPos, spriteScale, spriteDistPercentage, visible=true) {

		// calculate positioning
		let startPos = cameraPos;
		let direction = new THREE.Vector3();
		direction.subVectors(intersectionPos, startPos);

	    let finalPos = new THREE.Vector3();
	    finalPos.addVectors(startPos, direction.multiplyScalar(spriteDistPercentage));

		let canvas = document.createElement('canvas');
		let context = canvas.getContext('2d');
		context.canvas.width = 256;
		context.canvas.height = 256;

		// canvas contents will be used as a texture
		let texture = new THREE.Texture(canvas);
		texture.needsUpdate = true;

		// create the sprite and position it
		let spriteMaterial = new THREE.SpriteMaterial( { map: texture, color: 0xffffff } );
		let sprite = new THREE.Sprite(spriteMaterial);
		sprite.scale.set(spriteScale, spriteScale, spriteScale);
		sprite.position.set(finalPos.x, finalPos.y, finalPos.z);

		// fit the image into the texture size and add the sprite to the scene
		let spriteImage = new Image();
		spriteImage.src = this.spriteImagSrc;

		spriteImage.onload = function() {
			context.drawImage(spriteImage, 0, 0, spriteImage.width, spriteImage.height);
			viewer.scene.add(sprite);
		}

		if(!visible) {
			sprite.material.opacity = 0.0;
		}

		this.lastCreationTime = viewer.clock.getElapsedTime();
		return sprite;
	}

	addPortalSpriteMetaData(sprite, linkedSceneName, defaultScale) {

		sprite.meta = {};
		sprite.meta.linkedSceneName = linkedSceneName;
		sprite.meta.defaultScale = defaultScale;
		sprite.meta.type = "portal";
	}

	insertPortalFromJSON(jsonObject, visible=false) {

		let dataset = jsonObject.dataset;

		for(let i=0; i<dataset.length; i++) {

			let intersectionPoint = new THREE.Vector3(dataset[i].intersectionPoint.x, dataset[i].intersectionPoint.y, dataset[i].intersectionPoint.z);
			let linkedSceneName = dataset[i].linkedSceneName;
			let spriteScale = dataset[i].scale;
			let spriteDistPercentage = dataset[i].distPercentage;
			let hoverImage = dataset[i].previewImage;

			let sprite = this.createPortalSprite(viewer.camera.position, intersectionPoint, spriteScale, spriteDistPercentage, visible);
			this.addPortalSpriteMetaData(sprite, linkedSceneName, spriteScale);
			this.addPortalPulseEffect(sprite);
		}
	}

	getPortalIntersection(mousePos) {

		this.raycaster.setFromCamera(mousePos, viewer.camera);
		let intersects = this.raycaster.intersectObjects(viewer.scene.children);

		for (let i=0; i<intersects.length; i++) {

			if(intersects[i].object.type === "Sprite" && intersects[i].object.meta.linkedSceneName != null) {
				return intersects[i].object;
			}
		}

		return null;
	}

	getFirstPortal() {

		let target = null;

		viewer.scene.traverse (function (object) {

			if (object instanceof THREE.Sprite) {
				if(object.meta != undefined) {
					if(object.meta.type === "portal") {
						target = object;
					}
				}
			}
		});

		return target;
	}

	cancelNavigattionEffect() {

		if(viewer.isMobile) {
			viewer.deviceOrientationControls.connect();
		}

		this.isNavigating = false;
	}

	initiateNavigationEffect(portal=null) {

		if(this.isNavigating) {
			return;
		} else {
			this.isNavigating = true;
		}

		if(portal===null) {
			portal = this.getFirstPortal();
			if(portal===null) {
				this.cancelNavigattionEffect();
				return;
			}
		}

		if(viewer.isMobile) {
			viewer.deviceOrientationControls.disconnect();
		}

		this.initiateCameraLookatEffectWithSlerp(portal);
	}

	initiateCameraLookatEffect(portal) {

		let target = portal;
		let that = this;

		// release the camera lookat operation in the normal update loop
		viewer.manualCameraControl = true;

		// backup original rotation
		let origRot = new THREE.Euler().copy(viewer.camera.rotation);

		// simulate rotation with lookat
		viewer.camera.lookAt(target.position);
		let finalRot = new THREE.Euler().copy(viewer.camera.rotation);

		// restore original rotation
		viewer.camera.rotation.copy(origRot);

		// Perform the tweened rotation
		let tween = new TWEEN.Tween(viewer.camera.rotation).to({
		    x: finalRot.x,
		    y: finalRot.y,
		    z: finalRot.z
		}, 500).easing(TWEEN.Easing.Linear.None).onComplete(function () {
			that.initiateCameraFOVEffect(portal);
		}).start();
	}

	initiateCameraLookatEffectWithSlerp(portal) {

		let target = portal;
		let that = this;

		// release the camera lookat operation in the normal update loop
		viewer.manualCameraControl = true;

		// backup original rotation
		let origRot = new THREE.Euler().copy(viewer.camera.rotation);

		// simulate rotation with lookat
		viewer.camera.lookAt(target.position);
		let finalRot = new THREE.Euler().copy(viewer.camera.rotation);

		// restore original rotation
		viewer.camera.rotation.copy(origRot);

		// Perform the tweened rotation
		let qSrc = new THREE.Quaternion().copy(viewer.camera.quaternion);
		let qDest = new THREE.Quaternion().setFromEuler(finalRot);
		let qValue = new THREE.Quaternion();

		let valueObj = {t: 0};
		let tween = new TWEEN.Tween(valueObj).to({
			t: 1
		}, 500).easing(TWEEN.Easing.Linear.None).onUpdate(function() {
			THREE.Quaternion.slerp(qSrc, qDest, qValue, valueObj.t);
			viewer.camera.quaternion.set(qValue.x, qValue.y, qValue.z, qValue.w);
		}).onComplete(function () {
			that.initiateCameraFOVEffect(portal);
		}).start();
	}

	initiateCameraFOVEffect(portal) {

		let fovTarget = 10.0;
		let animTime = 500.0;
		let that = this;

		TweenHelpers.animateFloat(viewer.camera.fov, fovTarget, { duration: animTime, easing: TWEEN.Easing.Sinusoidal.InOut, update: function(result) { viewer.setFov(result.value) }, callback: function() { that.endNavigationEffect(portal) } });
	}

	endNavigationEffect(portal) {

		viewer.setDefaultFov();
		this.navigateThroughPortal(portal);
		viewer.manualCameraControl = false;

		if(viewer.isMobile) {
			viewer.deviceOrientationControls.connect();
		}

		this.isNavigating = false;
	}

	navigateThroughPortal(portal=null) {

		if(portal===null) {
			portal = this.getFirstPortal();
		}

		if(portal!=null) {
			viewer.loadScene(null, portal.meta.linkedSceneName);
			viewerUI.selectActiveSceneByName(portal.meta.linkedSceneName);
		}
	}

	addPortalPulseEffect(portal) {

		let fadeTime = 1000;
		let fadeUpValue = {o: this.pulseMinOpacity};
		let fadeDownValue = {o: this.pulseMaxOpacity};

		let fadeUpTween = new TWEEN.Tween(fadeUpValue).to({o: this.pulseMaxOpacity}, fadeTime)
		.easing(TWEEN.Easing.Cubic.InOut)
		.onUpdate(function () {
			portal.material.opacity = fadeUpValue.o;
		});

		let fadeDownTween = new TWEEN.Tween(fadeDownValue).to({o: this.pulseMinOpacity}, fadeTime)
		.easing(TWEEN.Easing.Cubic.InOut)
		.onUpdate(function () {
			portal.material.opacity = fadeDownValue.o;
		});

		fadeUpTween.onComplete(function() {
			fadeUpValue.o = this.pulseMinOpacity;
			fadeDownTween.start();
		});

		fadeDownTween.onComplete(function() {
			fadeDownValue.o = this.pulseMaxOpacity;
			fadeUpTween.start();
		});

		fadeUpTween.start();
	}

	updatePortalData() {

		let activeScene = sceneCollection.getActiveScene();
		if(activeScene.portalData != null) {
			this.insertPortalFromJSON(activeScene.portalData);
		}

		let that = this;
		setTimeout(function(){ that.showAllPortals(true); }, this.visibilityDelayInSeconds * 1e3);
	}

}